export default "__VITE_ASSET__DCJGlwir__"